<template>
  <SettingsMediaUpload
    prop="logo"
    section="images"
    :label="
      $t('_web_tournament_custom-settings_promotion_logo-label', 'Logo BG:')
    "
    :tooltip="
      $$t(
        'Tournament avatar, will be shown on tournament posts',
        'logo-tooltip'
      )
    "
  />
</template>

<script>
import SettingsMediaUpload from '@/views/tournaments/management/singleTournament/components/SettingsMediaUpload';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentLogoSetting',
  components: {
    SettingsMediaUpload,
  },
  mixins: [translate('_web_tournament_settings')],
};
</script>
